import { Component, OnInit } from '@angular/core';
import { SubvensionService } from 'app/services/subvension.service';
import { Subvension } from 'app/model/subvension';
import { AuthService } from 'app/services/auth.service';
import { NgxCarousel } from 'ngx-carousel';
import { RecommendationService } from 'app/services/recommendation.service';
import { isHK } from 'app/app.component';

@Component({
  selector: 'app-subvensions',
  templateUrl: './subvensions.component.html',
  styleUrls: ['./subvensions.component.css']
})
export class SubvensionsComponent implements OnInit {
  selectedModel: Subvension;

  public carouselSubs: NgxCarousel;
  isSU = false;

  constructor(
    public subvensionService: SubvensionService,
    private authService: AuthService,
    public recommendationService: RecommendationService) { }

  ngOnInit() {
    this.isSU = this.authService.isSuperUser();

    this.carouselSubs = {
      grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
      slide: 1,
      speed: 400,
      interval: 4000,
      point: {
        visible: true
      },
      load: 2,
      touch: true,
      loop: false,
      custom: 'banner'
    }
  }


  getIsHK(): boolean {
    return isHK;
  }

  onSelect(subvension: Subvension): void {
    this.selectedModel = subvension;
  }

  showSubvs() {
    return this.subvensionService.SUBVENSIONS !== undefined;
  }

  getSubvensions() {
    const subvs = this.subvensionService.getSubvensions();
    return subvs;
  }

  delete(id: string): void {
    this.subvensionService.delete(id);
  }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/subvensions/subvensions.component.ts